import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

// Import DM Mono from Google Fonts
const link = document.createElement("link");
link.rel = "stylesheet";
link.href = "https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500;700&display=swap";
document.head.appendChild(link);

// Global reset
const style = document.createElement("style");
style.textContent = `
  *, *::before, *::after { box-sizing: border-box; }
  body { margin: 0; padding: 0; background: #0d0d0d; }
  input:focus, textarea:focus { border-color: #e8ff47 !important; }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><App /></React.StrictMode>);
